import { AbstractControl, Validator, ValidationErrors, NG_VALIDATORS, ValidatorFn, FormGroup } from "@angular/forms";
import { Directive } from "@angular/core";

@Directive({
  selector: '[appValidatePasswords]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordsMismatchValidatorDirective, multi: true }]
})

export class PasswordsMismatchValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return passwordsMismatchValidator(control);
  }
}


export const passwordsMismatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const newPassword = control.get('password');
  const confirmPassword = control.get('confirmPassword');
  let x = newPassword && confirmPassword && newPassword.value !== confirmPassword.value ? { passwordsMismatch: true } : null;
  return x;
};
